module.exports = __webpack_public_path__ + "img/page-not-found.6df4a0a3.svg";